<template>
  <div id="app">
    
    <router-view></router-view>
  </div>
</template>

<script>
// @ is an alias to /src
import Navbar from './components/Navbar.vue'

export default {
  name: 'App',
  components: {
    Navbar
  }
}

</script>

<style>
#app {
  margin: auto;
  max-width: 400px;
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  height: auto;
}
</style>
